import type { RadioGroupFieldTypeConstraint } from '@bos/form';
import { FlexContainer } from '@bos/ui';
import type { Control, FieldPathByValue, FieldValues } from 'react-hook-form';

import type { AppRadioListItemProps } from '../../../../../../components/AppRadioListItem';
import { AppRadioListItem } from '../../../../../../components/AppRadioListItem';
import { AppRadioGroupField } from '../../../../../../components/form/AppRadioGroupField/AppRadioGroupField';
import { useGetBooleanToYesNo } from '../../../../../../hooks/translations/booleanToYesNo';
import { useI18nContext } from '../../../../../../locale/i18n-react';

export const WITHOUT_RESTRICTION = 'withoutRestriction';
export const IS_VALID = 'isValid';
export const IS_INVALID = 'isInvalid';

export type BinaryFilterRadioGroupProps<
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
> = {
	control: Control<TFieldValues>;
	name: TFieldName;
};

export const BinaryFilterRadioGroup = <
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
>({
	control,
	name,
}: BinaryFilterRadioGroupProps<TFieldValues, TFieldName>) => {
	const {
		LL: {
			clientDocuments: {
				filtersPopoverContent: filtersPopoverContentTranslate,
			},
		},
	} = useI18nContext();
	const booleanToYesNo = useGetBooleanToYesNo();

	const items: AppRadioListItemProps[] = [
		{
			value: WITHOUT_RESTRICTION,
			label: filtersPopoverContentTranslate.labels.withoutRestriction(),
		},
		{ value: IS_VALID, label: booleanToYesNo(true) },
		{ value: IS_INVALID, label: booleanToYesNo(false) },
	];

	return (
		<AppRadioGroupField control={control} name={name}>
			<FlexContainer direction={'column'} gap>
				{items.map((item) => (
					<AppRadioListItem
						key={item.value}
						value={item.value}
						label={item.label}
						divider={null}
					/>
				))}
			</FlexContainer>
		</AppRadioGroupField>
	);
};
